import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { useAllUserList } from '../../assets/api/useAdminApi'
import { Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import AddUserForm from '../admin/AddUserForm'
import useAuthStore from '../../store/useAuthStore'

const MarketingManagerAddZonalCoordinator = () => {
  const { user } = useAuthStore()
  const { data: allUserList, isLoading } = useAllUserList({ role: "Zonal Coordinator", city: user.city })
  const alluserColumns = [
    {
      field: "id",
      headerName: "Sr No",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

    },
    {
      field: "firstname",
      headerName: "First Name",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params?.row?.role === "student" ? params?.row?.lastname : params.value}</Typography>,
    },

    {
      field: "lastname",
      headerName: "Last Name",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params?.row?.role === "student" ? "" : params.value}</Typography>,
    },
    {
      field: "role",
      headerName: "Role",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "apartment_name",
      headerName: "Apartment Name",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },

  ];
  return (
    <>
      <NormalContainerWithHeader headerText={"Add Zonal Coordinator"}>
        <AddUserForm
          RoleOption={[{
            id: 1,
            label: 'Zonal Coordinator',
            value: "Zonal Coordinator"
          },]}
          role={"Zonal Coordinator"}
        />
      </NormalContainerWithHeader>
      <CustomDivider />
      <TableFilterTemplate
        title="Zonal Coordinator"
        columns={alluserColumns}
        rowsData={allUserList?.data || []}
        isLoading={isLoading}
      />
    </>

  )
}

export default MarketingManagerAddZonalCoordinator
